// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1fINM","log":"ModalInventoryLogs_log__BY482","date":"ModalInventoryLogs_date__2SbAe","userName":"ModalInventoryLogs_userName__2aZLn"};